import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'

import * as echarts from 'echarts'
import Api from './api/index.js';
import global from './global/global';

import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import './assets/index.css'
import mixins from './mixins/mixins.js'



axios.defaults.withCredentials=true;//让ajax携带cookie

Vue.prototype.$echarts = echarts

Vue.prototype.$axios = axios;
Vue.prototype.$global = global;

Vue.use(ElementUI)
Vue.mixin(mixins)
Vue.prototype.$api = Api;
Vue.directive('title', {
  inserted: function(el, binding) {// eslint-disable-line no-unused-vars
    document.title = el.dataset.title
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
